/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup, EuiSkeletonText } from '@elastic/eui'

import ConnectedClusterTable from '../ConnectedClusterTable'

import CCMClustersTileHeader from './CCMClustersTileHeader'
import EmptyConnectedClustersTile from './EmptyConnectedClustersTile'

import type { FC } from 'react'

const MAX_NUM_TABLE_ROWS = 5

const CCMClusterTitleContent: FC<{
  connectedClusters: any
  isLoading: boolean
  isSuccess: boolean
}> = ({ connectedClusters, isLoading, isSuccess }) => {
  if (isLoading) {
    return <EuiSkeletonText />
  }

  if (isSuccess && connectedClusters.items.length === 0) {
    return <EmptyConnectedClustersTile />
  }

  return (
    <EuiFlexGroup direction='column' gutterSize='m'>
      <CCMClustersTileHeader />
      <ConnectedClusterTable limit={MAX_NUM_TABLE_ROWS} />
    </EuiFlexGroup>
  )
}

export default CCMClusterTitleContent
